export const startOfDay = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate())
export const addDays = (d: Date, n: number) => new Date(d.getFullYear(), d.getMonth(), d.getDate() + n, d.getHours(), d.getMinutes())
export const addMonths = (d: Date, n: number) => new Date(d.getFullYear(), d.getMonth() + n, 1)
export const startOfWeek = (d: Date, weekStartsOn = 0) => addDays(startOfDay(d), -((d.getDay() - weekStartsOn + 7) % 7))
export const startOfMonth = (d: Date) => new Date(d.getFullYear(), d.getMonth(), 1)
export const sameDay = (a: Date, b: Date) => a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate()
export const fmtTime = (d: Date) => d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })
export const ymd = (d: Date) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
export const parseYmd = (s: string) => { const [y, m, d] = s.split('-').map(Number); return new Date(y!, m! - 1, d!) }
/** `<input type=datetime-local>` value in local time. */
export const toLocalInput = (d: Date) => `${ymd(d)}T${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`

/** The 6x7 grid of days shown for a month view (weeks start Sunday by default). */
export function monthGrid(anchor: Date, weekStartsOn = 0): Date[] {
  const first = startOfWeek(startOfMonth(anchor), weekStartsOn)
  return Array.from({ length: 42 }, (_, i) => addDays(first, i))
}

export interface Placed<T> { item: T; col: number; cols: number }

/** Lays out overlapping timed events side by side (classic column packing) for the week/day grid. */
export function packOverlaps<T extends { start: Date; end: Date }>(items: T[]): Array<Placed<T>> {
  const sorted = [...items].sort((a, b) => a.start.getTime() - b.start.getTime() || b.end.getTime() - a.end.getTime())
  const out: Array<Placed<T>> = []
  let cluster: Array<{ item: T; col: number }> = []
  let clusterEnd = 0
  const flush = () => { const cols = Math.max(1, ...cluster.map((c) => c.col + 1)); for (const c of cluster) out.push({ ...c, cols }); cluster = []; }
  for (const item of sorted) {
    if (cluster.length && item.start.getTime() >= clusterEnd) flush()
    const used = new Set(cluster.filter((c) => c.item.end.getTime() > item.start.getTime()).map((c) => c.col))
    let col = 0
    while (used.has(col)) col++
    cluster.push({ item, col })
    clusterEnd = Math.max(clusterEnd, item.end.getTime())
  }
  flush()
  return out
}
